const COUPONS = {
  BREADCRUMB_FIRST_ITEM: 'Cupons de Desconto',
  BROWSER_EXTENSION: {
    HEADING_TITLE: 'Os melhores cupons de desconto',
    HEADING_SUBTITLE: 'Adicione nossa extensão ao seu navegador!',
  },
  COUPON_WITH_NO_CODE: 'Link cuponado',
  COUPONS_LIMIT: 15,
  COUPONS_STORE_GA_EVENT_CATEGORY: 'coupons_store',
  DESCRIPTION:
    'Confira nossa seleção de cupons de desconto das principais lojas da internet. Para que encontre apenas códigos válidos, nossa equipe verifica cada cupom.',
  HEADING_TITLE: 'Os Melhores Cupons de Desconto',
  LAST_COUPONS: {
    BREADCRUMB_TEXT: 'Últimos cupons',
    DESCRIPTION:
      'Economize com a melhor seleção de Cupons de Desconto. Os últimos cupons das melhores lojas para você economizar sempre. Encontre aqui o cupom que você precisa!',
    HEADING_SUBTITLE:
      'Confira a lista dos últimos cupons adicionados no Promobit!',
    HEADING_TITLE: 'Últimos cupons',
    TITLE: 'Últimos cupons de desconto, O cupom que você precisa, no Promobit!',
  },
  OPEN_GRAPH: {
    DESCRIPTION:
      'Confira nossa seleção de cupons de desconto das principais lojas da internet. Para que encontre apenas códigos válidos, nossa equipe verifica cada cupom.',
    LAST_COUPONS_DESCRIPTION:
      'Economize com a melhor seleção de Cupons de Desconto. Os últimos cupons das melhores lojas para você economizar sempre. Encontre aqui o cupom que você precisa!',
    LAST_COUPONS_TITLE:
      'Últimos cupons de desconto, O cupom que você precisa, no Promobit!',
    TITLE: 'Promobit Cupom | Códigos e Cupons de Desconto Válidos',
  },
  PICK_COUPON: 'Pegar cupom',
  PROMOBIT_COUPON_CODE: 'promobit',
  PROMOBIT_COUPONS_BREADCRUMB_TEXT: 'Promobit',
  RETURN_COUPON: 'Voltar ao cupom',
  SEE_MORE_COUPONS: 'Ver mais cupons',
  SEE_ALL_COUPONS: 'Ver todos os cupons',
  TITLE: 'Promobit Cupom | Códigos e Cupons de Desconto Válidos',
  UNAVAILABLE_COUPON: 'Não temos nenhum cupom ativo no momento.',
  VERIFIED_COUPON: 'Cupom verificado hoje',
};

export default COUPONS;
